﻿(function () {
  'use strict';
  var controllerId = 'verifyTokenController';
  angular
    .module('app.common')
    .controller(controllerId, verifyTokenController);

  verifyTokenController.$inject = ['$scope', '$interval', '$rootScope', 'common', 'config', 'moment', 'datacontext', '$location', '$state', 'ngDialog','$window'];

  function verifyTokenController($scope, $interval, $rootScope, common, config, moment, datacontext, $location, $state, ngDialog, $window) {
    var vm = this;
    vm.dialog = null;
    init();

    function init() {
      $interval(verifyToken,
        10000);
    }

    $scope.closeDialog = closeSessionExpiredDialog;
    function verifyToken() {
      var authData = common.localStorageService.get('authorizationData');
      if (authData && authData.dateTime && authData.expires_in) {
        var expirationDate = moment(authData.dateTime).add(authData.expires_in, 's');
        var now = moment();
        if (now > expirationDate && !vm.dialog) {
          datacontext.auth.logOut(true);
          vm.dialog = ngDialog.open({
            template: 'verifyTokenTemplate',
            appendClassName: 'ngdialog-verify-session',
            width: 400,
            closeByEscape: false,
            showClose: false,
            closeByDocument: false,
            scope: $scope,
            preCloseCallback: function (value) {
              vm.dialog = null;
              $window.location.reload();
            }
          });
        }
      }
    }

    function closeSessionExpiredDialog() {
      vm.dialog.close();
    }
  }
})();